import React, { useState } from 'react';
import StepWizard from 'react-step-wizard';
import { NSModal } from 'bricks';
import { generatePath, useNavigate, useParams } from 'react-router-dom';
import { IOptionAnyValue } from 'bricks/types';
import useAuthContext from 'contexts/AuthContext';
import { useCreateProForma } from 'queries/ProForma';
import { URLS } from 'services/urls';
import CreateProFormaStep1 from './components/CreateProFormaStep1/CreateProFormaStep1';
import { CREATE_PRO_FORMA_STEPS } from './constants';

export interface ICreateProFormaModalProps {
    toggle: () => void;
    isOpen: boolean;
    initialScenario?: IOptionAnyValue;
    dealAssetTypeCorrelationId?: string;
    dealId?: number;
}

const CreateProFormaModal = ({
    toggle,
    isOpen,
    initialScenario,
    dealAssetTypeCorrelationId,
    dealId: selectedDealId,
}: ICreateProFormaModalProps) => {
    const { dealId: dealIdFromParams } = useParams<{ dealId: string }>();
    const dealId = selectedDealId ? String(selectedDealId) : dealIdFromParams;
    const { selectedOrganizationId } = useAuthContext();
    const navigate = useNavigate();

    const [proFormaModelId, setProFormaModelId] = useState<number | undefined>(undefined);
    const [selectedScenario, setSelectedScenario] = useState<IOptionAnyValue | undefined>(initialScenario);

    const { mutate: createProForma, isPending: isCreatingProForma } = useCreateProForma();

    const handleCreateProForma = (isWizardFlow: boolean = false) => {
        createProForma(
            {
                dealId: Number(dealId),
                selectedOrganizationId: String(selectedOrganizationId),
                scenarioId: selectedScenario?.value ? Number(selectedScenario.value) : undefined,
                proFormaModelId,
                isWizardFlow,
            },
            {
                onSuccess: data => {
                    const path = generatePath(isWizardFlow ? URLS.PRO_FORMA.WIZARD : URLS.PRO_FORMA.TABLE, {
                        dealId,
                        proFormaId: data.id.toString(),
                    });
                    navigate(path);
                },
                onError: error => {
                    console.error('Error creating pro forma:', error);
                },
            },
        );
    };

    return (
        <NSModal
            toggle={toggle}
            isOpen={isOpen}
            modalHeaderClassName="bg-primary modal-colored-header"
            modalHeaderText="Generate pro forma"
            modalFooterIsShown={false}
            size="lg"
        >
            <StepWizard
                key={initialScenario ? 'with-scenario' : 'without-scenario'}
                initialStep={CREATE_PRO_FORMA_STEPS.STEP_1}
                transitions={{
                    enterRight: '',
                    exitRight: '',
                }}
            >
                <CreateProFormaStep1
                    stepName={String(CREATE_PRO_FORMA_STEPS.STEP_1)}
                    dealId={Number(dealId)}
                    toggle={toggle}
                    initialScenario={initialScenario}
                    setProFormaModelId={setProFormaModelId}
                    proFormaModelId={proFormaModelId}
                    selectedScenario={selectedScenario}
                    setSelectedScenario={setSelectedScenario}
                    handleCreateProForma={handleCreateProForma}
                    isCreatingProForma={isCreatingProForma}
                    dealAssetTypeCorrelationId={dealAssetTypeCorrelationId}
                />
                {/* TODO: uncomment out if step 2 that includes the wizard is needed */}
                {/* <CreateProFormaStep2
                    stepName={String(CREATE_PRO_FORMA_STEPS.STEP_2)}
                    toggle={toggle}
                    showScenarioStep={showScenarioStep}
                    handleCreateProForma={handleCreateProForma}
                    isCreatingProForma={isCreatingProForma}
                /> */}
            </StepWizard>
        </NSModal>
    );
};

export default CreateProFormaModal;
